<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Local Expense Reimbursement
    </div>
    <div class="card-body">
        <form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
            <div class="row mx-1">
                <div class="col-md-3">
                    <label for="Type" class="form-font-label">Reimburse Type</label>
                    <select class="form-select" aria-label="ReimburseType" placeholder="Reimburse Type"
                        title="ReimburseType" name="ReimburseType" [(ngModel)]="Filter.ReimburseType"
                        (change)="ClearData()" #ReimburseType="ngModel" required>
                        <option disabled [value]=null>--Select Type--</option>
                        <option value="All">All</option>
                        <option value="Pending">Pending</option>
                        <option value="Reimbursed">Reimbursed</option>
                    </select>
                </div>
                <div class="col-md-3" style="display: none;">
                    <label for="Type" class="form-font-label">Travel Type</label>
                    <select class="form-select" aria-label="TravelType" placeholder="Travel Type" title="TravelType"
                        name="TravelType" [(ngModel)]="Filter.TravelType" (change)="ClearData()" #TravelType="ngModel"
                        required disabled>
                        <option disabled [value]=null>--Select Type--</option>
                        <!-- <option value="All">All</option> -->
                        <option value="Local">Local</option>
                        <!-- <option value="Outstation">Outstation</option> -->
                    </select>
                </div>
                <div class="col-md-3">
                    <label for="FromDateObj" class="form-font-label">From
                        Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateObj"
                            [(ngModel)]="Filter.FromDateObj" ngbDatepicker #FromDateObj="ngbDatepicker" 
                            (ngModelChange)="ClearData()"/>
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select from date!
                    </div>
                </div>
                <div class="col-md-3">
                    <label for="ToDateObj" class="form-font-label"> To
                        Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateObj"
                            [(ngModel)]="Filter.ToDateObj" ngbDatepicker #ToDateObj="ngbDatepicker" 
                            (ngModelChange)="ClearData()"/>
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select to date!
                    </div>
                </div>
                <!-- <div class="col-md-3"><br>
                    <button class="btn btn-primary" type="submit" [disabled]="isDisabled"><i
                            class="bi bi-cloud-download me-2" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Apply':'Loading...'}}</button>
                    &nbsp;&nbsp; <button class="btn btn-primary" *ngIf="this.common.PageRight.IsPrint" type="button"
                        [disabled]="isDisabled" (click)="exportToExcel()"><i class="bi bi-file-earmark-arrow-down"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Excel':'Loading...'}}</button>
                </div> -->
            </div>
            <!-- <div class="row mx-1 mt-2">
                <div class="col"></div>
                <div class="col-md-auto align-self-end">
                   
                </div>
            </div> -->
            <div class="row mx-1 mt-2">
                <div class="col">
                    <div class="col-md-3">
                        <label for="Status" class="form-font-label">Employee Type</label>
                        <select class="form-select" aria-label="Status" placeholder="Status" title="Status"
                            name="Status" [(ngModel)]="Filter.EmpType" #Status="ngModel" (change)="ClearData()"
                            required>
                            <option disabled [value]='null'>--Select EmpType--</option>
                            <!-- <option value="All">
                                <div class="row">
                                    <div class="col">All</div>
                                </div>
                            </option> -->
                            <option value="front">
                                <div class="row">
                                    <div class="col">Front</div>
                                </div>
                            </option>
                            <option value="back">
                                <div class="row">
                                    <div class="col">Back</div>
                                </div>
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-auto align-self-end"><br>
                    <button class="btn btn-primary" type="submit" [disabled]="isDisabled"><i
                            class="bi bi-cloud-download me-2" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Apply':'Loading...'}}</button>
                    &nbsp;&nbsp; <button class="btn btn-primary" *ngIf="this.common.PageRight.IsPrint" type="button"
                        [disabled]="isDisabled" (click)="exportToExcel()"><i class="bi bi-file-earmark-arrow-down"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Excel':'Loading...'}}</button>
                </div>
            </div>
        </form>
    </div>
</div>
<div class="card mt-2 border-radius-0 p-1">
    <!-- <div class="row">
        <div class="btn-group gap-1" role="group" aria-label="Basic example">
            <button type="button" class="btn btn-outline-primary" style="width:100%"
                [class.active]="Filter.EmpType === 'front'" (click)="FilterEmpType('front')" value="front">Front
                Office</button>
            <button type="button" class="btn btn-outline-primary" [class.active]="Filter.EmpType === 'back'"
                (click)="FilterEmpType('back')" style="width:100%" value="back">Back Office</button>
        </div>
    </div> -->
    <div class="card-body p-0">
        <div style="overflow: auto;">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 5px;">#</th>
                        <th scope="col"><input class="form-check-input header-check" type="checkbox" id="IsApproveAll"
                                name="IsApproveAll" (click)="ARCheck($event,0,true)"></th>
                        <th [ngClass]="{'colHide': !this.common.PageRight.IsView}">View</th>
                        <th [ngClass]="{'colHide': !this.common.PageRight.IsView}">Approval</th>
                        <th>Employee</th>
                        <th>Employee Type</th>
                        <th>ReportName</th>
                        <th style="width: 100px;">Request Date</th>
                        <th style="width: 100px;">Expense Type</th>
                        <th style="width: 100px;">Expense Total</th>
                        <th style="width: 300px;">Description</th>
                        <!-- <th style="display: none;">Reimbursement</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td class="text-center">
                            <div style="width: 20px;"><input class="form-check-input" type="checkbox"
                                    id="IsApprove{{i}}" name="IsApprove{{i}}" (click)="ARCheck($event,i)"
                                    [(ngModel)]="TableData['IsARCheck']">
                            </div>
                        </td>
                        <td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsView}">
                            <div style="width: 80px;"><button type="button" (click)="viewItem(i)"
                                    class="btn btn-outline-primary btn-sm"><i
                                        class="bi bi-info-square me-1"></i>View</button></div>
                        </td>
                        <td style="width: 5px; text-align: center;" [ngClass]="{'colHide': !this.common.PageRight.IsView}">
                            <div style="width: 60px;"><button type="button" (click)="viewApprovalMatrix(i)"
                                    class="btn btn-outline-primary btn-sm"><i
                                        class="bi bi-eye me-1"></i></button></div>
                        </td>
                        <td>
                            <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                                <div class="col-2">
                                    <img *ngIf="TableData['Photo'] != null && TableData['Photo'] != ''" mat-card-image
                                        class="userImage" [src]="common.PhotoLink(TableData['Photo'])" />
                                    <div *ngIf="TableData['Photo'] == null || TableData['Photo'] == ''"
                                        class="initial-image">
                                        <div class="image">
                                            {{common.getInitial(TableData['EmployeeName'])}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-9 userdetail">
                                    <span class="text-label-dark">{{TableData['EmployeeName']}}</span><br />
                                    <span class="text-label-light">#{{TableData['EmpCode']}}</span><br />
                                    <span class="text-label-light">{{TableData['DesignationName']}}</span><br />
                                    <span class="text-label-light">{{TableData['SiteName']}}</span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div style="width: 80px;">{{TableData['EmpType']}}</div>
                        </td>
                        <td>{{TableData['ReportName']}}</td>
                        <td>
                            <div style="width: 100px;">{{TableData['RequestDate'] | date : 'dd MMM yyyy'}}</div>
                        </td>
                        <td>
                            <div style="width: 100px;">{{TableData['ExpenseType']}}</div>
                        </td>
                        <td><span style="float: inline-end;">{{TableData['ExpenseTotal']}}</span></td>
                        <td>{{TableData['Description']}}</td>
                        <!-- <td style="width: 5px;display: none;">
                            <div style="width: 150px;"><button type="button"
                                    (click)="ESS_ExpenseRequestUpdateAtApproval()" class="btn btn-primary btn-sm"
                                    [disabled]="TableData['IsReimbursed']"><i
                                        class="bi bi-info-square me-1"></i>Reimbursement</button></div>
                        </td> -->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
            </div>
            <div class="col-auto">
                <!-- <button type="button" class="btn btn-primary mx-1" [disabled]="isDisabled"
                    (click)="ESS_ExpenseRequestUpdateAtApproval()"><i class="bi bi-check2" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Submit':'Loading...'}}</button> -->

                <button type="button" 
                    class="btn btn-primary mx-1" [disabled]="isDisabled"
                    (click)="ExcelDump()"><i *ngIf="!isDisabled" class="bi bi-download me-1"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Export to Excel':'Loading...'}}</button>

                <button type="button" *ngIf="this.common.PageRight.IsAdd || this.common.PageRight.IsEdit"
                    class="btn btn-success mx-1" [disabled]="isDisabled"
                    (click)="ESS_ExpenseRequestUpdateAtApproval()"><i class="bi bi-check2" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Reimburse':'Loading...'}}</button>
            </div>
        </div>
    </div>
</div>